import { render, staticRenderFns } from "./List-Orders.vue?vue&type=template&id=61b634d6"
import script from "./List-Orders.vue?vue&type=script&lang=js"
export * from "./List-Orders.vue?vue&type=script&lang=js"
import style0 from "./List-Orders.vue?vue&type=style&index=0&id=61b634d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports